module.exports = __webpack_public_path__ + "img/shipo-icon-ship.a29aa75b.svg";